/* Shopify's native cookie consent banner (#shopify-pc__banner) is injected
   asynchronously by Shopify itself, so a MutationObserver is used to catch it
   as soon as it appears and swap in our own copy. Ported from the jQuery
   version in BROADCAST/assets/custom.js. */
(function () {
  var DEFAULT_TITLE = 'Obligatory Cookie Popup 🍪';
  var CUSTOM_BODY =
    'We use cookies to keep your cart and personalizations saved. It also lets us know if you added something to cart to help us track metrics. — nothing creepy, no data sharing or selling. More in our ';

  function applyCookieBannerCopy(banner) {
    var title = banner.querySelector('#shopify-pc__banner__body-title');
    var body = banner.querySelector('.shopify-pc__banner__body p');
    if (!title || !body) return;

    var link = body.querySelector('#shopify-pc__banner__body-policy-link');

    // Only swap the known default English copy - if Shopify served different
    // (regional/legal) wording, leave it alone rather than risk clobbering it
    // if (title.textContent.trim() !== DEFAULT_TITLE || !link) return;

    title.textContent = DEFAULT_TITLE;
    body.innerHTML = CUSTOM_BODY + (link ? link.outerHTML : '');
  }

  function init() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner) { applyCookieBannerCopy(banner); return; }

    var observer = new MutationObserver(function () {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner) {
        observer.disconnect();
        applyCookieBannerCopy(banner);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
